import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContext from "../../context/app/context";
import OrderNoteContext from "../../context/order-note/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import OrderNoteContextProvider from "../../context/order-note/provider";
import SearchFilterCard from "../../components/general/filter-card";
import Can from "../../utils/rbac/can";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import {Permissions} from "../../utils/Permissions/Permissions";
import OrderNoteTable from "../../components/order-note/order-note-table";
interface IProps {
  children?: React.ReactNode;
}

const OrderNote: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(OrderNoteContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);
  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("order_notes")}
        subTitle={t("order_notes_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
          <Can key={2} perform={Permissions.CAN_CREATE_ORDER_NOTE}>
            <Button
              type="primary"
              onClick={() => {
                navigate(`/order-note/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_order_note")}
            </Button>
          </Can>,
        ]}
      />
      <SearchFilterCard
        formId="order_note-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          });
          const form = document.getElementById("order_note-filter");
          if (form) {
            form.dispatchEvent(new Event("reset", { cancelable: true, bubbles: true }));
          }
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        {/* <UserFilter /> */}
      </SearchFilterCard>

      <OrderNoteTable />
    </div>
  );
};

const OrderNotePage = () => {
  return (
    // ContextProvider
    <OrderNoteContextProvider>
      <OrderNote />
    </OrderNoteContextProvider>
  );
};
export default OrderNotePage;
